import type { GatsbyBrowser } from "gatsby";
import "hp-theme/src/styles/tokens.css";
import "hp-theme/src/styles/base.css";

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // Client-side only code
};
